export enum AudioType {
	AM_SYNTH = 'AMSynth',
	FM_SYNTH = 'FMSynth',
	FILE = 'file',
	MONO_SYNTH = 'monoSynth',
	POLY_SYNTH = 'polySynth',
	SAMPLER = 'sampler',
	SWITCH = 'switch',
	SYNTH = 'synth',
}
